import React, { useState,useEffect, useContext} from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import PropTypes from 'prop-types';
import moment from 'moment';
import Tooltip from '@material-ui/core/Tooltip';
// common components
import CustomButton from './../../../common/Forms/CustomButton/CustomButton';
import CustomAvatar from './../../../common/Avatar/Avatar';
import Loader from './../../../common/Loader/Loader';
// css
import './ModuleList.scss';

const ModuleList = ({moduleQuestion, manageModules, moduleList,moduleContext}) => {

	const [dndModuleList,setDndModuleList]= useState(moduleList);

	useEffect(()=>{
		setDndModuleList(moduleList)
	},[moduleList]);

	function handleOnDragEnd(result) {
		if (!result.destination) return;
		const items = Array.from(dndModuleList);
		const [reorderedItem] = items.splice(result.source.index, 1);
		items.splice(result.destination.index, 0, reorderedItem);
		//Creating body object as per required for backend
		const body = {
			course_id : items[0].course_id,
			module_idList : items.map(x=>x.id)
		}
		moduleContext.setModuleOrder(body)//Sending body to moduleContext to make api call after drag and drop
		setDndModuleList(items);
	}

	if(dndModuleList && dndModuleList.length > 0) {
		return(
		<div>
			<div className='dnd-header'>
				<p className='dnd-title'>Drag and Drop to Reorder the Modules</p>
				{/* <div><button>Sort by Date</button></div> */}
			</div>
			<div className="ModuleList" >
		    <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="list">
			{(provided) => (
				<div {...provided.droppableProps} ref={provided.innerRef}>
				{dndModuleList.map(({id,name,description,question_count,created_date,image_uploaded},index) => {
                    id=id.toString();
					return(
					<Draggable key={id} draggableId={id} index={index}>
					{(provided) => (
					<div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
					<div className="row card-view" key={id} style={{marginTop:"10px"}}>
						<div className="col col-lg card-heading first">
							<CustomAvatar name={name} />
							<div className="heading">
								<div className="title" onClick={()=> moduleQuestion(id)}>{name}</div>
								<Tooltip title={description} placement="bottom">
									<div className="desc">{description}</div>
								</Tooltip>
							</div>
						</div>
						<div className="col-12 col-lg details second">
							<div className="row card-detail">
								<div className="col">
									<div className="title"># of Questions</div>
									<div className="value">{question_count}</div>
								</div>
								{/* <div className="col">
									<div className="title">created by</div>
									<div className="value">Jayaprakash</div>
								</div> */}
								<div className="col">
									<div className="title">created date</div>
									<div className="value">{moment(created_date).format('DD MMM YYYY')}</div>
								</div>							
							</div>
						</div>
						<div className="col cardview-actions third">
							{ image_uploaded === 'Y' &&
								<CustomButton
									iconOnly
									iconName='image'
								/>
							}
							<div className="line" />
							<CustomButton
								iconOnly
								iconName='edit'														
								onClick={() => manageModules(true,'edit',id)}
							/>
							<CustomButton
								iconOnly
								iconName='delete'									
								onClick={() => manageModules(true,'delete',id)}
							/>
						</div>
					</div>
					</div>
					)}
					</Draggable>
	            );
				})}
				{provided.placeholder}
			    </div>
			)}	
		    </Droppable>
            </DragDropContext>
			</div>
		</div>
		);
	}
	return (<Loader />);
}

ModuleList.propTypes = {
	moduleQuestion: PropTypes.func,
	manageModules: PropTypes.func,
	moduleList: PropTypes.instanceOf(Array)
};

ModuleList.defaultProps = {
	moduleQuestion: () => {},
	manageModules: () => {},
	moduleList: []
};

export default ModuleList;


// WEBPACK FOOTER //
// ./components/CourseModule/ModuleList/ModuleList.js